import styled from '@emotion/styled';
import { forwardRef, Ref, useEffect, useState } from 'react';
import { Season } from './apiService';
import EpisodeList from './EpisodeList';
import SeasonSelector from './SeasonSelector';
import useConditionalProps from './utils/useConditionalProps';

type SeriesContentProps = {
  seasons: Season[];
  season?: number;
  episode?: number;
  onScrollToEpisodes?: () => void;
};

const Container = styled.div(({ theme }) => ({
  position: 'relative',
  marginBottom: theme.spacing(7),
}));

const SeriesContent = ({ seasons, season: seasonNumber, onScrollToEpisodes }: SeriesContentProps, ref: Ref<HTMLDivElement>) => {
  const [index, setIndex] = useState<number>(findSelectedSeason(seasons, seasonNumber));
  const active: Season = seasons[index];
  const { episodes } = active || {};

  const reactions = useConditionalProps((s) => s.seasons);
  const activeReactions = reactions?.[active?.id || -1];

  const handleSeasonChange = (index: number) => {
    setIndex(index);
    onScrollToEpisodes?.();
  };

  useEffect(() => {
    setIndex(findSelectedSeason(seasons, seasonNumber));
  }, [seasonNumber, seasons]);

  return (
    <Container ref={ref}>
      <SeasonSelector seasons={seasons} active={index} onChange={handleSeasonChange} />
      <EpisodeList episodes={episodes} reactions={activeReactions} />
    </Container>
  );
};

function findSelectedSeason(seasons: Season[], season?: number): number {
  if (!season) return 0;
  return seasons.findIndex((s) => s.season === season);
}

export default forwardRef<HTMLDivElement, SeriesContentProps>(SeriesContent);
